"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollbackError = void 0;
var tslib_1 = require("tslib");
var PersistentError_1 = require("./PersistentError");
var RollbackError = /** @class */ (function (_super) {
    tslib_1.__extends(RollbackError, _super);
    function RollbackError(cause) {
        return _super.call(this, 'The transaction has been roll backed', cause) || this;
    }
    return RollbackError;
}(PersistentError_1.PersistentError));
exports.RollbackError = RollbackError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUm9sbGJhY2tFcnJvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlJvbGxiYWNrRXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLHFEQUFvRDtBQUVwRDtJQUFtQyx5Q0FBZTtJQUNoRCx1QkFBWSxLQUFZO2VBQ3RCLGtCQUFNLHNDQUFzQyxFQUFFLEtBQUssQ0FBQztJQUN0RCxDQUFDO0lBQ0gsb0JBQUM7QUFBRCxDQUFDLEFBSkQsQ0FBbUMsaUNBQWUsR0FJakQ7QUFKWSxzQ0FBYSJ9